import React from "react";

const Spinner = ({ height }: any) => {
  const styles = {
    spinnerStyle: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: height,
    },
    innerSpinnerStyle: {
      width: "35px",
      height: "35px",
      border: "5px solid #f3f3f3",
      borderTop: "5px solid #3498db",
      borderRadius: "50%",
      animation: "spin 1.5s linear infinite",
    },
  };

  return (
    <div style={styles.spinnerStyle}>
      <div style={styles.innerSpinnerStyle}></div>
    </div>
  );
};

export default Spinner;
